export default __webpack_public_path__ + "static/media/regulatory--no-heavy-goods-vehicles--g2.9fff7565.png";